import MasterclassHeader from './components/MasterclassHeader';
import MasterclassOverview from './components/MasterclassOverview';
import MasterclassTopics from './components/MasterclassTopics';
import GuestSpeaker from './components/GuestSpeaker';
import ProgramHighlights from '../seminar/components/ProgramHighlights';
import DayByDayProgram from '../seminar/components/DayByDayProgram';
import BookingSection from '../seminar/components/BookingSection';
import Footer from '../home/components/Footer';

export default function MasterclassPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="text-2xl font-bold text-gray-900">
              Dubai <span className="text-yellow-500">Business Club</span>
            </a>
            <div className="flex items-center space-x-8">
              <a href="/" className="text-gray-700 hover:text-yellow-500 transition-colors font-medium whitespace-nowrap">
                Startseite
              </a>
              <a href="/masterclass" className="text-gray-700 hover:text-yellow-500 transition-colors font-medium whitespace-nowrap">
                Dubai Masterclass
              </a>
              <a href="#bewerbung" className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white px-6 py-2 rounded-full font-bold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
                Jetzt bewerben
              </a>
            </div>
          </div>
        </div>
      </nav>
      <MasterclassHeader />
      <MasterclassOverview />
      <ProgramHighlights />
      <MasterclassTopics />
      <DayByDayProgram />
      <GuestSpeaker />
      <BookingSection />
      <Footer />
    </div>
  );
}
